import { render, staticRenderFns } from "./ngo-info.html?vue&type=template&id=69a1e654&scoped=true&external"
import script from "./ngo-info.js?vue&type=script&lang=js&external"
export * from "./ngo-info.js?vue&type=script&lang=js&external"
import style0 from "./ngo-info.scss?vue&type=style&index=0&id=69a1e654&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a1e654",
  null
  
)

export default component.exports